// Shim for Node-only modules like fs in a browser build.
// If anything actually tries to use it, fail loudly.
const handler: ProxyHandler<any> = {
	get(_t, key) {
		throw new Error(`Node module is not available in browser build (attempted: ${String(key)})`)
	}
}

export default new Proxy({}, handler)
export const promises = new Proxy({}, handler)
